
import {Route, Routes, useParams} from "react-router-dom";
import Header from "../../layouts/Header";
import Listing from "./Listing";
import Details from "./Details";



const LogsManager = (props) => {
    const {id} = useParams()

    return (
        <>
            <Header
                icon="elink"
                title="Logs Manager"
            />
            <Routes>
                <Route index element={<Listing/>}/>
                <Route path=":id" element={<Details id={id}/>}/>
                {/*<Route path="new" element={<Create/>}/>
                */}
            </Routes>
        </>
    )
}

export default LogsManager